// extracted by mini-css-extract-plugin
export default {"overviewWraper":"header_overviewWraper__92QAD","heading":"header_heading__8Oh7i","zDynamicState4":"header_zDynamicState4__hdevE","popper":"header_popper__ruv7T"};